import React from 'react';
import useStores from '../../hooks/useStores';

interface Props {
  data: {
    quantity: number;
  };
}

const QuantityButton = ({ data }: Props) => {
  const { cart, checkout } = useStores();

  const removeProduct = async (variation, quantity) => {
    await cart.removeItem(variation.code, quantity);
    await checkout.loadPaymentMethods();
  };

  const addProduct = async (variation?) => {
    await cart.addItem(variation.code);
    await checkout.loadPaymentMethods();
  };

  return (
    <div className="flex justify-center">
      <div className="flex border rounded h-9 border-solid border-rgrey-light font-axi-bold text-sm justify-center items-center">
        <button
          className="transition-all duration-100 cursor-pointer lg:hover:bg-black lg:hover:text-white py-2 px-2.5 rounded-tl rounded-bl border-r-rgrey-light lg:hover:border-r-black border-r border-solid"
          onClick={() => removeProduct(data, 1)}
          aria-label="Eemalda kogus"
        >
          <span>-</span>
        </button>
        {data.quantity >= 1 ? (
          <span className="px-4 py-2">{data.quantity}</span>
        ) : null}
        <button
          className="transition-all duration-100 cursor-pointer lg:hover:bg-black lg:hover:text-white py-2 px-2.5 rounded-tr rounded-br border-l-rgrey-light lg:hover:border-l-black border-l border-solid
"
          onClick={() => addProduct(data)}
          aria-label="Lisa kogus"
        >
          <span>+</span>
        </button>
      </div>
    </div>
  );
};

export default QuantityButton;
